export const showCustomLoader = () => {
  const loaderContainer = document.createElement('div');
  loaderContainer.className = 'custom-image-loader';
  
  const spinner = document.createElement('img');
  spinner.src = '/images/preloader.png';
  spinner.style.width = '60px';
  spinner.style.height = '67px';
  spinner.style.animation = 'spin 1s linear infinite';
  
  const overlay = document.createElement('div');
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.background = 'rgba(255,255,255,0.8)';
  overlay.style.zIndex = '9999';
  overlay.style.display = 'flex';
  overlay.style.alignItems = 'center';
  overlay.style.justifyContent = 'center';
  
  overlay.appendChild(spinner);
  loaderContainer.appendChild(overlay);
  document.body.appendChild(loaderContainer);
  
  const style = document.createElement('style');
  style.textContent = `
    @keyframes spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);
  
  return {
    hide: () => {
      const el = document.querySelector('.custom-image-loader');
      if (el) document.body.removeChild(el);
      if (style.parentNode) document.head.removeChild(style);
    }
  };
};
